export const LOCAL_KEYS = {
  TOKEN:"token"
}
